import { AirplaneTakeoff, CalendarCheck, CaretRight } from "@phosphor-icons/react";
import { useNavigate } from "react-router-dom";

const FlightBookingChoice = () => {
  const navigate = useNavigate();

  return (
    <div className="p-10 px-5 md:px-10 flex flex-col gap-10 max-w-4xl mx-auto w-full">
      <div className="flex flex-col gap-2">
        <h1 className="text-4xl font-medium">
          How would you like to book your flight?
        </h1>
        <div className="text-gray-500">
          Choose the option that works best for you.
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
        {/* In-app booking — the existing /aviation flow */}
        <button
          type="button"
          onClick={() => navigate("/aviation")}
          className="group flex flex-col gap-5 border rounded-2xl p-6 md:p-8 text-left hover:border-visaro-orange/40 hover:bg-gray-50 transition-all"
        >
          <div className="w-12 h-12 rounded-full bg-visaro-orange/10 text-visaro-orange grid place-items-center">
            <CalendarCheck weight="bold" className="size-6" />
          </div>
          <div className="flex flex-col gap-1">
            <div className="font-medium text-xl">Book a flight</div>
            <div className="text-gray-500">
              Fly Now. Pay in full or pay over time.
            </div>
          </div>
          <div className="mt-auto pt-2 flex items-center gap-1 text-visaro-orange font-medium text-sm">
            <span>Continue</span>
            <CaretRight
              weight="bold"
              className="size-4 group-hover:translate-x-0.5 transition-transform"
            />
          </div>
        </button>
        
        {/* Book on Visaro Travels — standalone site (travels.visaro.ng).
            Gated OFF: Travels cannot take payment yet (its checkout "Proceed to
            Payment" is disabled) and international search is down on expired
            provider credentials. Re-enable only once Travels has a working
            standalone checkout — see .plans/state-of-play-sdk-and-marketplace.html. */}
        <div
          aria-disabled="true"
          className="flex flex-col gap-5 border rounded-2xl p-6 md:p-8 text-left opacity-60 cursor-not-allowed"
        >
          <div className="w-12 h-12 rounded-full bg-deepBlue/10 text-deepBlue grid place-items-center">
            <AirplaneTakeoff weight="bold" className="size-6" />
          </div>
          <div className="flex flex-col gap-1">
            <div className="flex items-center gap-2">
              <div className="font-medium text-xl">Book on Visaro Travels</div>
              <span className="text-xs font-medium px-2 py-0.5 rounded-full bg-gray-100 text-gray-600">
                Coming soon
              </span>
            </div>
            <div className="text-gray-500">
              Fast flight search and direct checkout.
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default FlightBookingChoice;
